import projection from '../generated/pwg504f1.json';
import { AcceptanceManifest } from '../types';

export const pwg504f1AcceptanceManifest = projection as AcceptanceManifest;
